import { ExportButton, useListContext } from 'react-admin';

export const CustomExportButton = (props: any) => {
  const { gridChildren, exporter, maxExportResults, ...otherProps } = props;
  const { total, exporter: defaultExporter } = useListContext(otherProps);
//TODO: big total amount can shotdown server
  const maxResults = maxExportResults ? (total < maxExportResults ? total : maxExportResults) : total || 1000
  return (<ExportButton maxResults={maxResults} exporter={exporter || defaultExporter}/>)
}